/* 🤖 this file was generated by svg-to-ts */
export const matIconTitle: {
  name: 'title';
  data: string;
} = {
  name: 'title',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 4v3h5.5v12h3V7H19V4H5z"/></svg>`
};
